import { useState } from "react";
import PropTypes from "prop-types";

//css
import "./Tooltip.scoped.scss";

const Tooltip = props => {
	const {
		text,
		theme = "dark",
		position = "right",
		compact = false,
		customHover = false,
		icon = <i className="fas fa-question-circle" />,
		onMobile = true,
		...otherProps
	} = props;

	const [hovering, setHovering] = useState(false);

	const toggleHover = s => {
		(window.matchMedia("hover: hover").matches || onMobile) && setHovering(s);
	};

	return (
		<div
			className={`tooltip tooltip--${theme} tooltip--${position} ${compact ? "tooltip--compact" : ""}`}
			{...otherProps}
		>
			<div className="tooltip__icon" onMouseOver={() => toggleHover(true)} onMouseOut={() => toggleHover(false)}>
				{otherProps.children || icon}
			</div>
			<div className={`tooltip__body ${(hovering || customHover) && "show"}`}>{text}</div>
		</div>
	);
};

Tooltip.propTypes = {
	text: PropTypes.string.isRequired,
	theme: PropTypes.string,
	position: PropTypes.string,
	compact: PropTypes.bool,
	customHover: PropTypes.bool,
	onMobile: PropTypes.bool
};

export default Tooltip;
